export const fieldsNameToRemove = [
    { name: 'tx_news_pi1[overwriteDemand][period]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][related]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][categories]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][day]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][month]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][year]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][keywords]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][datecomplete]', ignoreZero: false },
    { name: 'tx_news_pi1[search][subject]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][tags]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][relatedLinks]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][related]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][relatedLocations]', ignoreZero: false },
    { name: 'tx_news_pi1[overwriteDemand][relatedAreas]', ignoreZero: false },
    { name: 'tx_simplepoll_polllisting[category]', ignoreZero: true },
    { name: 'tx_simplepoll_polllisting[status]', ignoreZero: true },
    { name: 'tx_stratismap_location[search][keywords]', ignoreZero: false },
    { name: 'tx_stratismap_location[search][categories][]', ignoreZero: false },
];

export const subjectRelatedFields = [
    'tx_news_pi1[__referrer][@request]',
    'tx_news_pi1[__referrer][@extension]',
    'tx_news_pi1[__referrer][@vendor]',
    'tx_news_pi1[__referrer][@controller]',
    'tx_news_pi1[__referrer][@action]',
    'tx_news_pi1[__referrer][arguments]',
    'tx_news_pi1[__trustedProperties]',
];

export const datecompleteRelatedFields = [
    'tx_news_pi1[overwriteDemand][startFromThisDate]',
];

export const locationRelatedFields = [
    'tx_stratismap_location[__referrer][@extension]',
    'tx_stratismap_location[__referrer][@vendor]',
    'tx_stratismap_location[__referrer][@controller]',
    'tx_stratismap_location[__referrer][@action]',
    'tx_stratismap_location[__referrer][arguments]',
    'tx_stratismap_location[__referrer][@request]',
    'tx_stratismap_location[__trustedProperties]',
];
